class CosProductCatalogSection extends HTMLElement {
  constructor() {
    super()
    this.swipers = new Map()
    this.currentTab = null
  }

  async connectedCallback() {
    await ResourceCoordinator.requestVendor('Swiper')
    this.init()
  }

  disconnectedCallback() {
    this.swipers.forEach(swiper => swiper && swiper.destroy(true, true))
    this.swipers.clear()
  }

  init() {
    const tabsEnabled = this.querySelector('.cos-tab-link')
    if (tabsEnabled) {
      this.initializeTabs()
    } else {
      this.initializeSwiper('default')
    }
    this.setupResizeHandler()
  }

  initializeTabs() {
    const tabLinks = this.querySelectorAll('.cos-tab-link')
    if (tabLinks.length > 0) {
      const firstTab = tabLinks[0].dataset.tab
      this.currentTab = firstTab
      this.initializeSwiper(firstTab)
    }

    tabLinks.forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault()
        this.switchTab(link.dataset.tab)
      })
    })
  }

  switchTab(tabName) {
    if (tabName === this.currentTab) return

    this.querySelectorAll('.cos-tab-link').forEach(link => {
      link.classList.toggle('is-active', link.dataset.tab === tabName)
    })

    this.querySelectorAll('.cos-tab-content').forEach(content => {
      if (content.dataset.tab === tabName) {
        content.classList.remove('hidden')
        content.classList.add('block')
      } else {
        content.classList.add('hidden')
        content.classList.remove('block')
      }
    })

    if (!this.swipers.has(tabName)) {
      this.initializeSwiper(tabName)
    }

    this.currentTab = tabName
  }

  initializeSwiper(key) {
    if (window.innerWidth >= 768 || typeof Swiper === 'undefined') return

    const handle = key === 'default' ? 'default' : key.toLowerCase().replace(/[^a-z0-9]/g, '-')
    const swiperEl = this.querySelector(`.cos-catalog-swiper-${handle}`)
    if (!swiperEl) return

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      freeMode: true,
      grabCursor: true,
      pagination: false,
      navigation: false,
    })

    this.swipers.set(key, swiper)
  }

  setupResizeHandler() {
    let resizeTimer
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(() => this.handleResize(), 150)
    })
  }

  handleResize() {
    const isMobile = window.innerWidth < 768

    if (isMobile && this.swipers.size === 0) {
      const tabsEnabled = this.querySelector('.cos-tab-link')
      if (tabsEnabled && this.currentTab) {
        this.initializeSwiper(this.currentTab)
      } else if (!tabsEnabled) {
        this.initializeSwiper('default')
      }
    } else if (!isMobile && this.swipers.size > 0) {
      this.swipers.forEach(swiper => swiper && swiper.destroy(true, true))
      this.swipers.clear()
    }
  }
}

customElements.define('cos-product-catalog-section', CosProductCatalogSection)
